import { Component, Input } from '@angular/core';
import { ITitleSectionInformation } from '../../interfaces/title-section-information.interface';

@Component({
  standalone: false,
  selector: 'title-small-section',
  templateUrl: './title-small-section.component.html',
  styleUrls: ['./title-small-section.component.scss'],
})
export class TitleSmallSectionComponent {
  @Input() titleSectionInformation: ITitleSectionInformation;
}
